import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import  {initiateAdminOAuthLogin, initiateLogOut } from '../services/OauthUtils';
import { useTranslation } from '../../TranslationContext';
// import axios from 'axios';


interface SubHeaderProps {
  isDarkMode: boolean;
}

const SubHeader: React.FC<SubHeaderProps> = ({ isDarkMode }) => {
  // const Post_logout = import.meta.env.VITE_REDIRECT_post_logout_redirect_uri
  const { t } = useTranslation();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('company'));
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showSuccessModal] = useState(false);
  // const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkLoginStatus = () => {
      setIsLoggedIn(!!localStorage.getItem('company'));
    };
    
    checkLoginStatus();
    window.addEventListener('storage', checkLoginStatus);
    
    return () => {
      window.removeEventListener('storage', checkLoginStatus);
    };
  }, []);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };


  const handleAdminDashboard = () => {
    navigate('/EntrepriseDashboard');
  };

  return (
    <div className={`${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'} border-b`}>
      <div className="items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-end space-x-4">
          {isLoggedIn ? (
            <button
              onClick={handleAdminDashboard}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-800"
            >
              {t('admin_dashboard')}
            </button>
          ) : (
            <Link
              to="/BecomeClient"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-800"
            >
              {t('become_client')}
            </Link>
          )}

          {isLoggedIn ? (
            <button
              onClick={handleLogoutClick}
              className={`inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md ${
                isDarkMode
                  ? 'border-gray-600 text-gray-300 bg-gray-700 hover:bg-gray-600'
                  : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
              }`}
            >
              {t('logout')}
            </button>
          ) : (
            <button
              onClick={initiateAdminOAuthLogin}
              className="inline-flex items-center cursor-pointer px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700"
            >
              {t('sign_in')}
            </button>
          )}
        </div>
      </div>


      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
          <div className={`relative max-w-md w-full mx-4 rounded-lg shadow-lg p-6 ${
            isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
          }`}>
            <div className="text-center">
              <div className={`mb-4 flex justify-center ${isDarkMode ? 'text-yellow-400' : 'text-yellow-500'}`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold mb-4">{t('confirmLogout')}</h2>
              <p className={`mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                {t('logoutQuestion')}
              </p>
              <div className="flex space-x-3 justify-center">
                <button 
                  onClick={handleCancelLogout}
                  className={`px-4 py-2 rounded-md font-medium ${
                    isDarkMode 
                      ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' 
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {t('cancel')}
                </button>
                <button 
                  onClick={initiateLogOut}
                  className="px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700"
                >
                  {t('confirm')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSuccessModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
          <div className={`relative max-w-md w-full mx-4 rounded-lg shadow-lg p-6 ${
            isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
          }`}>
            <div className="text-center">
              <div className={`mb-4 flex justify-center ${isDarkMode ? 'text-green-400' : 'text-green-500'}`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold mb-4">{t('success_title')}</h2>
              <p className={isDarkMode ? 'text-gray-300' : 'text-gray-600'}>
                {t('success_message')}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubHeader;


